import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const postAchievementsCheck = payload =>
  httpClient.post(apis.POST_ACHIEVEMENTS_CHECK, payload);
